import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_ADMIN, PATH_USER, PATH_KIOSK } from '../routes/paths';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  type: PropTypes.oneOf(['user', 'admin', 'kiosk']),
  children: PropTypes.node,
};

export default function GuestGuard({ type, children }) {
  const { isAuthenticated, isInitialized, user } = useAuth();

  if (isAuthenticated && type === 'user' && user?.role === 'user') {
    return <Navigate to={PATH_USER.dashboard} />;
  } 
   if (isAuthenticated && type === 'admin' && user?.role === 'org') {
    return <Navigate to={PATH_ADMIN.dashboard} />;
  } 
   if (isAuthenticated && type === 'kiosk' && user?.role === 'kiosk') {
    return <Navigate to={PATH_KIOSK.home} />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
